// https://github.com/component/scroll-to/blob/master/index.js
import raf from "./raf"; // Return scroll position

function scroll() {
  var x = window.pageXOffset || document.documentElement.scrollLeft;
  var y = window.pageYOffset || document.documentElement.scrollTop;
  return {
    left: x,
    top: y
  };
} // ease easeOutCubic


function easeOutCubic(pos) {
  return Math.pow(pos - 1, 3) + 1;
} // Scroll to `(x, y)`.


function scrollTo(x, y, options, callback, container) {
  if (options === void 0) {
    options = {};
  }

  if (callback === void 0) {
    callback = function callback() {};
  }

  if (container === void 0) {
    container = window;
  }

  var stop = false;
  var from = scroll(); // @ts-ignore: Unreachable code error

  var duration = options.duration || 1000;
  var start = Date.now(); // Update position

  function update() {
    var now = Date.now();

    if (now - start >= duration) {
      stop = true;
    } // easeOutCubic


    var percent = easeOutCubic((now - start) / duration);
    var toY = from.top + (y - from.top) * percent;
    container.scrollTo(x, toY);
  } // animate


  function animate() {
    if (stop) {
      callback();
      return;
    }

    raf(animate);
    update();
  }

  animate();
}

export default scrollTo;